// extracted by mini-css-extract-plugin
module.exports = {"order-history":"order-history-cf43f99dde58898829e5519b63548ce3"};